<!--
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2024-12-09 15:24:42
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2025-01-16 09:39:56
 * @FilePath: /epec-purchase-shopping-mall/Users/douyunfei/Documents/epec-ea/src/modules/projectA/pages/nesting/components/auditReport.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!--  -->
<template>
  <div>
    <e-table-list :table-data="tableData" :table-label="tableLabel">
      <template #auditReportFile="slot">
        <div>
          <eui-btn
            type="text"
            @click="handleOpen(slot.scope.row.auditReportFile)"
            >查看</eui-btn
          >
        </div>
      </template>
    </e-table-list>
  </div>
</template>

<script>
import ETableList from '@/modules/projectA/components/common/e-table-list';

export default {
  components: { ETableList },
  props: {
    reportList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      // tableData: [],
      tableLabel: [
        {
          label: '名称',
          align: 'center',
          param: 'reportName',
          width: '180',
        },
        {
          label: '审计报告附件',
          param: 'auditReportFile',
          align: 'center',
          minWidth: '100',
          slot: 'auditReportFile',
        },
        {
          label: '年份',
          param: 'year',
          align: 'center',
          minWidth: '100',
        },
        {
          label: '更新时间',
          param: 'gsnFileDate',
          align: 'center',
          minWidth: '100',
        },

        {
          label: '状态',
          param: 'status',
          align: 'center',
          minWidth: '100',
          render: (item) => {
            return item.status === 1 || item.status === undefined
              ? '待确认'
              : '已确认';
          },
        },
      ],
    };
  },

  computed: {
    tableData() {
      return this.reportList;
    },
  },

  created() {},
  methods: {
    handleOpen(url) {
      window.open(url);
    },
  },
};
</script>
<style lang="scss" scoped></style>
